import { render, staticRenderFns } from "./reelInstagram.vue?vue&type=template&id=123c169e&"
import script from "./reelInstagram.vue?vue&type=script&lang=js&"
export * from "./reelInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports